var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4ZielpublikumBreitesPublikum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aZielPublikum{fill:none;}.bZielPublikum{fill:#b30200;}.cZielPublikum{fill:#707070;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aZielPublikum",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bZielPublikum",
    d: "M114.016,158.22a8.75,8.75,0,1,1,8.75-8.75A8.759,8.759,0,0,1,114.016,158.22Zm0-14a5.25,5.25,0,1,0,5.25,5.25A5.256,5.256,0,0,0,114.016,144.22Zm0,32.25a27,27,0,1,1,27-27A27.031,27.031,0,0,1,114.016,176.47Zm0-50a23,23,0,1,0,23,23A23.026,23.026,0,0,0,114.016,126.47Z",
    transform: "translate(-66.016 -101.471)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cZielPublikum",
    d: "M114.016,166.47a17,17,0,1,1,17-17A17.019,17.019,0,0,1,114.016,166.47Zm0-30a13,13,0,1,0,13,13A13.014,13.014,0,0,0,114.016,136.47Zm0,52a39,39,0,1,1,39-39A39.044,39.044,0,0,1,114.016,188.47Zm0-74a35,35,0,1,0,35,35A35.04,35.04,0,0,0,114.016,114.47Z",
    transform: "translate(-66.016 -101.471)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4ZielpublikumBreitesPublikum);
export default __webpack_public_path__ + "static/media/4_zielpublikum_breites_publikum.5dce9d9c75e13f724831f21f1762468e.svg";
export { ForwardRef as ReactComponent };